<div id="cfet-doc-upload-container">
  <div *ngIf="!docUploadAccordioanModal">
    <div class="row no-gutters" id="doc-upload-content">
      <div class="col-md-12">
        <h2 id="doc-upload-heading">
          <strong>{{cfetLabels.cfet_doc_upload.doc_upload_heading}}</strong>
        </h2>
        <p id="doc_upload-subheading">{{cfetLabels.cfet_doc_upload.doc_upload_subheading}}
        </p>
      </div>
    </div>

    <div class="row no-gutters" id="uploaded-file-section" *ngIf="fileList.length > 0">
      <div class="col-md-12">
        <!-- ngFor: file in fileList -->
        <div class="uploaded-result-column" id="uploaded-result-column"
          *ngFor="let file of fileList; let $index=index;">
          <div id="file-format-input" class="row no-gutters file-format-input">
            <div class="col-1 uploaded-doc-image"> <img [src]=[file.imageurl] alt=""></div>
            <div class="col-10">
              <p class="uploaded-document-name">{{file.file.name}} </p>
            </div>
            <div class="col-1" id="iconClose" (click)="removeSelectedFile($index, $event, file.file.name)"
              (keyup.enter)="removeSelectedFile($index, $event, file.file.name)" tabindex="0">
              <img src="assets/images/trash_16.png" alt="Delete File">
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row no-gutters" id="doc-upload-footer-column">
      <div class="col-md-12" *ngIf="showUploadButton">
        <button type="button" id="upload-btn" (click)="fileInput.click() ; removeError()" tabindex="0"
          [ngClass]="fileUploaded ? 'confirm-color-change' : 'btn btn-alt btn-medium upload-btn'">
          <span *ngIf="fileUpload">
            <img class="photos" src="assets/images/D059_Photos_24-1.png" alt="Photos">
            {{cfetButtonLabels.button_labels.upload}}</span>
          <span *ngIf="fileUploaded">
            <img class="photos" src="assets/images/D059_Photos_24.png" alt="Photos">
            {{cfetButtonLabels.button_labels.uploadAnother}}</span>
        </button>
        <label for="file-upload" style="display:none;">File Upload Sonar Fix</label>
        <input #fileInput #attachments type="file" name="file-upload" id="file-upload" style="display:none;"
          (change)="onFileChange($event)" />
      </div>

      <div class="col-md-12" *ngIf="showUploadingButton">
        <button type="button" id="uploading-btn" tabindex="0" class="btn btn-alt btn-medium"
          [disabled]="disabledUploadingButton">
          {{cfetButtonLabels.button_labels.uploading}}
          <div class="progress">
            <div id="progressBar" class="progress-bar" tabindex="0" aria-valuenow="50" aria-valuemin="0"></div>
          </div>
        </button>
      </div>

      <div class="col-md-12" *ngIf="showDoneButton">
        <button type="button" id="done-btn" (click)="done($event)" (keyup)="done($event)" tabindex="0"
          aria-label="Done button" class="btn btn-alt btn-medium"
          [ngClass]="{'add-space': hideUploadButton}">{{cfetButtonLabels.button_labels.done}}
        </button>
      </div>

      <div class="col-md-12">
        <a data-dismiss="modal" *ngIf="!disableSkipButton" (click)="skipUpload($event)" (keyup)="skipUpload($event)"
          tabindex="0" type="button" id="skip_link" class="btn btn-secondary btn-clear skip_link"
          [ngClass]="{'skip-disabled': disableSkipButton}" aria-disabled="false"><em aria-label=""></em>
          {{cfetButtonLabels.button_labels.skip}}</a>
        <a data-dismiss="modal" *ngIf="disableSkipButton" (click)="skipUpload($event)" (keyup)="skipUpload($event)"
          tabindex="0" type="button" id="skip_link" class="btn btn-secondary btn-clear skip_link"
          [ngClass]="{'skip-disabled': disableSkipButton}" aria-label="disabled skipForNow" aria-disabled="true"><em
            aria-label=""></em>
          {{cfetButtonLabels.button_labels.skip}}</a>
      </div>

    </div>

    <div class="row no-gutters accordions-list-container">
      <div class="col-md-12">
        <p id="doc-upload-acc-heading">
          <strong>{{cfetLabels.cfet_doc_upload.doc_upload_accheading}}</strong>
        </p>
        <div app-abs-accordion role="tablist" id="ac1" class="tiny-accordion" *ngIf="showIDAccordion">
          <app-abs-accordion-group id="eligibilityVerification-EmployeeBadgeAccordian" heading="AT&T advantages"
            [(isOpen)]="OpenEmployeeBadge" [tabindex]="0" abs-accessibility-click="13,32" (click)="goToModal('ID')"
            (onKeyUp)="goToModal('ID')">
            <div app-abs-head class="accordian-header">
              <em abs-expand-collapse-toggle
                [ngClass]="{'icon-accordion-plus':!OpenEmployeeBadge,'icon-accordion-minus':OpenEmployeeBadge}"
                [tabindex]="0" abs-accessibility-click="13,32" (click)="goToModal('ID')" aria-label="expand-toggle"
                (onKeyUp)="goToModal('ID')"></em>
              <div class="row accordian-header-title">
                <div id="employeeBadge"
                  [ngClass]="{'heading-medium':!OpenEmployeeBadge, 'b2b-blue':'OpenEmployeeBadge'}">
                  <img id="emp-black" src="assets/images/C028_EmployeeID_32.png" alt="Employee or volunteer ID">
                  <img id="emp-blue" src="assets/images/C028_EmployeeID_32-B.png" alt="Employee or volunteer ID">
                  <h1 style="display:none;">Fix for sonar issues</h1>
                  <h2 style="display:none;">Fix for sonar issues</h2>
                  <h3 style="display:none;">Fix for sonar issues</h3>
                  <h4 class="acc-heading" [innerHTML]="cfetLabels.cfet_doc_upload.employee_badge_heading"></h4>
                </div>
              </div>
            </div>
          </app-abs-accordion-group>
        </div>
        <div app-abs-accordion role="tablist" id="ac2" class="tiny-accordion" *ngIf="showPayAccordion">
          <app-abs-accordion-group id="eligibilityVerification-EmployeePayAccordian" heading="AT&T advantages"
            [(isOpen)]="OpenEmployeePay" [tabindex]="0" abs-accessibility-click="13,32" (click)="goToModal('EmpPay')"
            (onKeyUp)="goToModal('EmpPay')">
            <div app-abs-head class="accordian-header">
              <em abs-expand-collapse-toggle
                [ngClass]="{'icon-accordion-plus':!OpenEmployeePay,'icon-accordion-minus':OpenEmployeePay}"
                [tabindex]="0" abs-accessibility-click="13,32" (click)="goToModal('EmpPay')" aria-label="expand-toggle"
                (onKeyUp)="goToModal('EmpPay')"></em>
              <div class="row accordian-header-title">
                <div id="employeePay" [ngClass]="{'heading-medium':!OpenEmployeePay, 'b2b-blue':'OpenEmployeePay'}"
                  abs-expand-collapse-toggle>
                  <img src="assets/images/C026_Billing_32.png" alt="Employee paystub">
                  <h1 style="display:none;">Fix for sonar issues</h1>
                  <h2 style="display:none;">Fix for sonar issues</h2>
                  <h3 style="display:none;">Fix for sonar issues</h3>
                  <h4 class="acc-heading">{{cfetLabels.cfet_doc_upload.employee_pay_stub_heading}}</h4>
                </div>
              </div>
            </div>
          </app-abs-accordion-group>
        </div>
        <div app-abs-accordion role="tablist" id="ac3" class="tiny-accordion" *ngIf="showCertAccordion">
          <app-abs-accordion-group id="eligibilityVerification-CertificationAccordian" heading="AT&T advantages"
            [(isOpen)]="OpenCertification" [tabindex]="0" abs-accessibility-click="13,32"
            (click)="goToModal('Certificate')" (onKeyUp)="goToModal('Certificate')">
            <div app-abs-head class="accordian-header">
              <em abs-expand-collapse-toggle
                [ngClass]="{'icon-accordion-plus':!OpenCertification,'icon-accordion-minus':OpenCertification}"
                [tabindex]="0" abs-accessibility-click="13,32" (click)="goToModal('Certificate')"
                aria-label="expand-toggle" (onKeyUp)="goToModal('Certificate')"></em>
              <div class="row accordian-header-title">
                <div id="certification"
                  [ngClass]="{'heading-medium':!OpenCertification, 'b2b-blue':'OpenCertification'}"
                  abs-expand-collapse-toggle>
                  <img src="assets/images/C018_File_24.png" alt="Certification">
                  <h1 style="display:none;">Fix for sonar issues</h1>
                  <h2 style="display:none;">Fix for sonar issues</h2>
                  <h3 style="display:none;">Fix for sonar issues</h3>
                  <h4 class="acc-heading">{{cfetLabels.cfet_doc_upload.certification_heading}}</h4>
                </div>
              </div>
            </div>
          </app-abs-accordion-group>
        </div>
        <div app-abs-accordion role="tablist" id="ac4" class="tiny-accordion" *ngIf="showSignedAccordion">
          <app-abs-accordion-group id="eligibilityVerification-SignedLetterAccordian" heading="AT&T advantages"
            [(isOpen)]="OpenSignedLetter" [tabindex]="0" abs-accessibility-click="13,32"
            (click)="goToModal('SignedLetter')" (onKeyUp)="goToModal('SignedLetter')">
            <div app-abs-head class="accordian-header">
              <em abs-expand-collapse-toggle
                [ngClass]="{'icon-accordion-plus':!OpenSignedLetter,'icon-accordion-minus':OpenSignedLetter}"
                [tabindex]="0" abs-accessibility-click="13,32" (click)="goToModal('SignedLetter')"
                aria-label="expand-toggle" (onKeyUp)="goToModal('SignedLetter')"></em>
              <div class="row accordian-header-title">
                <div id="signedLetter" [ngClass]="{'heading-medium':!OpenSignedLetter, 'b2b-blue':'OpenSignedLetter'}"
                  abs-expand-collapse-toggle>
                  <img src="assets/images/C062_My_Notes_32.png" alt="Signed Letter">
                  <h1 style="display:none;">Fix for sonar issues</h1>
                  <h2 style="display:none;">Fix for sonar issues</h2>
                  <h3 style="display:none;">Fix for sonar issues</h3>
                  <h4 class="acc-heading">{{cfetLabels.cfet_doc_upload.signed_letter_heading}}</h4>
                </div>
              </div>
            </div>
          </app-abs-accordion-group>
        </div>
      </div>
    </div>

    <div class="row no-gutters" id="doc-upload-footer-warning-column">
      <div class="col-md-12 footer-content" [ngClass]="{'file-upload-height': !showCertAccordion}">
        <p class="footer-txt" [innerHTML]="cfetLabels.cfet_doc_upload.file_desc"></p>
        <p class="warning-msg">{{cfetLabels.cfet_doc_upload.warning_text}}</p>
      </div>
    </div>
  </div>
  <div [ngClass]="(accModalClicked === true) ? 'modal-remove-backdrop' : ''">
    <app-accordion-modal-popup [docUploadAccordioanModal]="docUploadAccordioanModal"
      (accordionModalCloseEvent)="closeModal($event)" [selectedOrg]="selectedOrg" [isEmpVolID]="isEmpVolID"
      [isEmpPay]="isEmpPay" [isCert]="isCert" [isSignedLetter]="isSignedLetter" [fname]="fname" [lname]="lname"
      #childModal>
    </app-accordion-modal-popup>
  </div>
  <div [ngClass]="(deleteModalClicked === true) ? 'delete-modal' : ''">
    <app-file-confirmation-delete-modal [openModal]="openFileDeleteModal"
      (modalCloseEvent)="closeDeleteFileModal($event)" [selectedFile]="selectedFile">
    </app-file-confirmation-delete-modal>
  </div>
  <div [ngClass]="(skipModalClicked === true) ? 'skip-modal' : ''">
    <app-skip-for-now-modal [openModal]="openSkipFileUploadModal" (modalCloseEvent)="closeSkipFileUploadModal($event)">
    </app-skip-for-now-modal>
  </div>
</div>